import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import StlViewer from './stlViewer';
import { stlModelUrl } from '../../lib/stlModels';

// "3D preview" section shown as a button; the (heavy) StlViewer only mounts —
// and only then lazy-loads three.js and fetches the STL — when the user opts in.
export default class Stl3dSection extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    toggle = () => {
        this.setState(prev => ({ open: !prev.open }));
    };

    render(props, { open }) {
        const { models, entityPlural, id } = props;
        if (!models || models.length === 0 || !id) {
            return null;
        }
        return (
            <div class='px-3 mt-3'>
                <button type='button' class='btn btn-outline-secondary rounded-pill w-100' onClick={this.toggle}>
                    <i class={`fa-duotone ${open ? 'fa-xmark' : 'fa-cube'} me-1`} />
                    {open
                        ? <Text id='product.3d-hide'>Hide 3D model</Text>
                        : <Text id='product.3d-show'>Show 3D model</Text>}
                </button>
                {open && (
                    <div class='mt-2'>
                        <StlViewer
                            key={models[0].md5}
                            src={stlModelUrl(entityPlural, id, models[0].md5)}
                            style='width:100%; height:50vh;'
                        />
                    </div>
                )}
            </div>
        );
    }
}
